import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary-900 text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 items-start">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-600 to-accent-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">FT</span>
              </div>
              <span className="font-heading font-bold text-lg">1ST TRUST FINANCES</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Helping businesses access funding faster. Connect with 70+ trusted lenders and find the perfect financing solution for your business.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-primary-800 hover:bg-primary-700 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-primary-800 hover:bg-primary-700 rounded-lg flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-primary-800 hover:bg-primary-700 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-primary-800 hover:bg-primary-700 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="lg:text-right">
            <h3 className="font-heading font-semibold text-lg mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/finance/fast-business-cash" className="text-gray-300 hover:text-white transition-colors">
                  Business Loans
                </Link>
              </li>
              <li>
                <Link to="/finance/invoice-finance" className="text-gray-300 hover:text-white transition-colors">
                  Invoice Finance
                </Link>
              </li>
              <li>
                <Link to="/finance" className="text-gray-300 hover:text-white transition-colors">
                  Asset Finance
                </Link>
              </li>
              <li>
                <Link to="/finance" className="text-gray-300 hover:text-white transition-colors">
                  Merchant Cash Advance
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="lg:text-right">
            <h3 className="font-heading font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/knowledge/how-to-fund" className="text-gray-300 hover:text-white transition-colors">
                  Knowledge
                </Link>
              </li>
              <li>
                <Link to="/finance" className="text-gray-300 hover:text-white transition-colors">
                  Finance Options
                </Link>
              </li>
              <li>
                <Link to="/insurance/companies" className="text-gray-300 hover:text-white transition-colors">
                  Insurance Claims
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:text-left">
            <h3 className="font-heading font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              {/* <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-accent-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">Phone</p>
                  <a href="tel:+441234567890" className="text-white hover:text-accent-400 transition-colors">
                    +44 (0) 123 456 7890
                  </a>
                </div>
              </li> */}
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-accent-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">Email</p>
                  <a href="mailto:Support@1stTrustfi.com" className="text-white hover:text-accent-400 transition-colors">
                    Support@1stTrustfi.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-accent-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">Address</p>
                  <p className="text-white text-sm">
                    The Manor House 
                    260 Ecclesall road south<br />
                    Sheffield, S11 9PS
                    UNITED KINGDOM
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-primary-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2026 1ST TRUST FINANCES. All rights reserved.
            </p>
            {/* <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/cookies" className="text-gray-400 hover:text-white transition-colors">
                Cookie Policy
              </Link> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
